import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ImageModal from "../../../../components/imageModal";
import {
  PURCHASE_MODE_NAMES,
  PURCHASE_STEPS_TYPE,
  PURCHASE_TYPE,
  PURCHASE_USED_KEY
} from "../../../../constants/purchase";
import { PURCHASE, SHOW_OWNER_USERS } from "../../../../constants/urls";
import { Confirm } from "../../../../components/confirm";
import { PremiumFeatureAction } from "../../../../actions";
import { WARNING_SINGLE_BUTTON_TEXT } from "../../../../constants/otherTexts";

const NewProjectDeniedModal = props => {
  const {
    modalData: {
      message,
      isWarning,
      isUpgrade,
      disableClose,
      viewOwnerUsers,
      ownerId,
      appliedLimits
    },
    modalStatus,
    history,
    closeModal
  } = props;

  const acceptButtonClickHandle = () => {
    closeModal();
    setTimeout(() => {
      let data = {
        [PURCHASE_USED_KEY.FORM_STEP]: PURCHASE_STEPS_TYPE.CHOOSE_PLAN,
        [PURCHASE_USED_KEY.OWNER_ID]: ownerId,
        [PURCHASE_USED_KEY.APPLIED_LIMITS]: appliedLimits
      };
      if (isUpgrade) {
        history.push({
          pathname: PURCHASE,
          state: {
            ...data,
            [PURCHASE_USED_KEY.PURCHASE_ACTION]: PURCHASE_TYPE.UPGRADE
          }
        });
      } else {
        history.push({
          pathname: PURCHASE,
          state: {
            ...data,
            [PURCHASE_USED_KEY.PURCHASE_ACTION]: PURCHASE_TYPE.NEW
          }
        });
      }
    }, 1);
  };
  const acceptButtonRenderText = () => {
    if (isUpgrade) {
      return PURCHASE_MODE_NAMES[PURCHASE_TYPE.UPGRADE];
    } else {
      return PURCHASE_MODE_NAMES[PURCHASE_TYPE.NEW];
    }
  };
  if (isWarning) {
    return (
      <Confirm
        show={modalStatus}
        close={closeModal}
        rejectHandler={closeModal}
        content={{
          type: "warning",
          icon: "icon mapsa-notification",
          message: message,
          rejectButtonText: WARNING_SINGLE_BUTTON_TEXT
        }}
      />
    );
  } else if (modalStatus) {
    return (
      <ImageModal
        show={modalStatus}
        closeHandler={disableClose ? undefined : () => closeModal()}
        imageIcon="Premium_tankhahgardan_icon.svg"
        description={message}
        rightButtons={[]}
        leftButtons={[
          {
            type: "ghost",
            borderless: false,
            onClick: () => {
              closeModal();
            },
            title: "انصراف"
          },
          {
            type: "primary",
            borderless: true,
            onClick: acceptButtonClickHandle,
            title: acceptButtonRenderText()
          }
        ]}
      >
        {viewOwnerUsers && (
          <div
            className="bottom-left-link"
            onClick={() => {
              history.push({
                pathname: `${SHOW_OWNER_USERS}/${ownerId}`,
                state: { isUpgrade }
              });
              closeModal()
            }}
          >
            <div>بررسی نسبی وضعیت کاربران مالک</div>
          </div>
        )}
      </ImageModal>
    );
  } else {
    return null;
  }
};

const mapStateToProps = store => {
  return {
    modalData: store.PremiumFeature.modalData,
    modalStatus: store.PremiumFeature.modalStatus
  };
};
const mapDispatchToProps = dispatch => {
  return {
    closeModal: () => {
      dispatch(PremiumFeatureAction.closeModal());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(NewProjectDeniedModal));
